import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { SharedLocType } from '../../shared.locs';

const dpRoot = 'System|Localization|Dialog';

export type LocalizationDialogLocs =
	| 'CMSystemLocalizationDialogDelete'
	| 'CMSystemLocalizationDialogCancel'
	| 'CMSystemLocalizationDialogSave'
	| 'CMSystemLocalizationDialogAllowHTML'
	| 'CMSystemLocalizationDialogDescription'
	| 'CMSystemLocalizationDialogNewValue'
	| 'CMSystemLocalizationDialogShared'
	| 'CMSystemLocalizationDialogDialogTitle'
	| 'CMSystemLocalizationDialogCurrentLanguage'
	| 'CMSystemLocalizationDialogSystemId'
	| 'CMSystemLocalizationDialogFeature'
	| 'CMSystemLocalizationDialogChangesSaved';

export const localizationModalLocs: LocDefs<LocalizationDialogLocs> = {
	CMSystemLocalizationDialogCancel: {
		defaultValue: 'Cancel Changes',
		displayPath: `${dpRoot}|Cancel Changes`,
		description: 'Button to cancel the changes and close the localize modal.',
		displayType: 'Button',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogDelete: {
		defaultValue: 'Delete',
		displayPath: `${dpRoot}|Delete Label`,
		description: 'Accessibility label for the delete localization button.',
		displayType: 'Button',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogSave: {
		defaultValue: 'Save Changes',
		displayPath: `${dpRoot}|Save Changes`,
		description: 'Button to save the changes and close the localize modal.',
		displayType: 'Button',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogAllowHTML: {
		defaultValue: 'Allows HTML',
		displayPath: `${dpRoot}|Allow HTML`,
		description: 'Label for the "allows html" section.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogDescription: {
		defaultValue: 'Description',
		displayPath: `${dpRoot}|Description`,
		description: 'Label for the description. This is both on the string and HTML editor.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogNewValue: {
		defaultValue: 'New Value',
		displayPath: `${dpRoot}|New Value`,
		description: 'Label for the new defaultValue.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogShared: {
		defaultValue: 'Shared',
		displayPath: `${dpRoot}|Shared`,
		description: 'Label for the "shared" section.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogDialogTitle: {
		defaultValue: 'Localizing',
		displayPath: `${dpRoot}|Title`,
		description: 'Title of the localize modal.',
		displayType: 'Title',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogCurrentLanguage: {
		defaultValue: 'Current Language',
		displayPath: `${dpRoot}|Current Language`,
		description: 'The accessibility text for the language select.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogSystemId: {
		defaultValue: 'System ID',
		displayPath: `${dpRoot}|System ID`,
		description: 'Identifier for the localization in the system.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogFeature: {
		defaultValue: 'Feature',
		displayPath: `${dpRoot}|Feature`,
		description: 'Feature for the localization.',
		displayType: 'Label',
		portal: 'All',
		feature: HubFeature.Core,
	},
	CMSystemLocalizationDialogChangesSaved: {
		defaultValue: 'Changes Saved',
		displayPath: `${dpRoot}|Changes Saved`,
		description: 'Content of the notification when localization changes are saved.',
		displayType: 'Notification',
		portal: 'All',
		feature: HubFeature.Core,
	},
};

export type DialogLocType = LocMap<LocalizationDialogLocs> & SharedLocType;
export const LOC_KEYS = MapLocKeys<LocalizationDialogLocs>(localizationModalLocs);
